import axios from "axios";
import { Configuration, OpenAIApi } from "openai";
import { randomIntFromInterval } from "../../Utils";

const prefix = "APP";
// const snooze = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const appActions = {
  LOADING: `${prefix}_LOADING`,
  BLOG_FETCH_SUCCESS: `${prefix}_BLOGS_FETCH_SUCCESS`,
  BLOG_FETCH_ERROR: `${prefix}_BLOGS_FETCH_ERROR`,
  BLOG_SAVE: `${prefix}_BLOG_SAVE`,
  BLOG_INIT: `${prefix}_BLOG_INIT`,
  
  getTranscript: async (videoId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const transcript = await axios.post(
          `https://api.tube2blog.com:5005`,
          { videoid: videoId },
          {}
        );
        if (transcript.data.error) {
          reject(`Transcript not found`);
        } else {
          const subtitles = transcript.data.subtitle;
          const subtitleList = subtitles.map((subtitle) => subtitle.text);
          resolve(subtitleList.join(". "));
          console.log(subtitleList);
          console.log(subtitles);
        }
      } catch (e) {
        reject(e);
      }
    });
  },
  getTopics: async (title, text, userId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const configuration = new Configuration({
          apiKey: "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",
        });
        const openai = new OpenAIApi(configuration);
        const topicsList = [];
        let counter = 0;
        do {
          const response = await openai.createCompletion("text-davinci-001", {
            prompt: `Pick out the bloggable topics from this text in relation to "${title} \n\n\n ${text.substring(
              0,
              1800
            )}" `,
            temperature: 0.7,
            max_tokens: 64,
            top_p: 1,
            frequency_penalty: 0,
            presence_penalty: 2,
            user: userId,
          });
          if (
            response.status === 200 &&
            response.data.choices &&
            response.data.choices.length > 0
          ) {
            const choice = response.data.choices[0];
            const isSafe = await appActions.applyContentFilter(
              choice.text,
              userId
            );
            if (isSafe) {
              let topics =
                choice.text.split("\n-").length >
                choice.text.split(/\n.\./).length
                  ? choice.text.split("\n-")
                  : choice.text.split(/\n.\./);
              topics = topics.filter(
                (topic) =>
                  topic.length > 5 &&
                  !topic.includes("be blogged about") &&
                  !topicsList.includes(topic)
              );
              topicsList.push(...topics);
            }
          }
          counter++;
        } while (topicsList.length < 6 && counter < 5);
        const titleHeadings = [`Introduction: ${title}`];
        const byTitle = await appActions.getHeadingsByTitle(title, userId);
        titleHeadings.push(...byTitle);
        titleHeadings.push(...topicsList);
        titleHeadings.push(`Conclusion: ${title}`);
        if (titleHeadings.length > 0)
          return resolve(titleHeadings.map((topic) => topic.trim()));
        else reject("No Topic found");
      } catch (e) {
        reject(e);
      }
    });
  },
  applyContentFilter: async (prompt, userId) => {
    try {
      const response = await axios.post(
        `https://api.openai.com/v1/engines/content-filter-alpha/completions`,
        {
          prompt: "<|endoftext|>" + prompt + "\n--\nLabel:",
          temperature: 0,
          max_tokens: 1,
          top_p: 0,
          logprobs: 10,
          user: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 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`,
          },
        }
      );
      if (response.data["choices"][0]["text"] === "2") {
        const logprobs = response["choices"][0]["logprobs"]["top_logprobs"][0];
        if (logprobs < -0.355) return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  },
  getHeadingsByTitle: async (title, userId) => {
    try {
      const configuration = new Configuration({
        apiKey: "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",
      });
      const openai = new OpenAIApi(configuration);
      const titlesList = [];
      let counter = 0;
      let prompt = `Create an outline for a blog about \"${title}\"`;
      do {
        const response = await openai.createCompletion("text-davinci-001", {
          prompt: prompt,
          temperature: 0,
          max_tokens: 679,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          best_of: 1,
          user: userId,
        });
        if (
          response.status === 200 &&
          response.data.choices &&
          response.data.choices.length > 0
        ) {
          const choice = response.data.choices[0];
          const isSafe = await appActions.applyContentFilter(
            choice.text,
            userId
          );
          if (isSafe) {
            let titles =
              choice.text.split("\n-").length >
              choice.text.split(/\n.\./).length
                ? choice.text.split("\n-")
                : choice.text.split(/\n.\./);
            titles = titles.filter(
              (topic) => topic.length > 5 && !titlesList.includes(topic)
            );
            
            titlesList.push(...titles);
          }
        }
        counter++;
      } while (titlesList.length < 6 && counter < 5);
      return titlesList.map((topic) => topic.trim());
    } catch (e) {
      return [];
    }
  },
  getHeading: async (title, topics, userId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const configuration = new Configuration({
          apiKey: "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",
        });
        topics = topics.map((topic) => topic.trim());
        const openai = new OpenAIApi(configuration);
        let titlesList = [];
        let counter = 0;
        let prompt = `transform these topics into catchy blog titles relating to \"${title}\" \n\n\n-`;
        let topicsPrompt = topics.join(" \n-");
        prompt = prompt + `${topicsPrompt}`;
        do {
          const response = await openai.createCompletion("text-davinci-001", {
            prompt: prompt,
            temperature: 0.7,
            max_tokens: 100,
            top_p: 1,
            frequency_penalty: 0,
            presence_penalty: 2,
            best_of: 1,
            user: userId,
          });
          if (
            response.status === 200 &&
            response.data.choices &&
            response.data.choices.length > 0
          ) {
            const choice = response.data.choices[0];
            const isSafe = await appActions.applyContentFilter(
              choice.text,
              userId
            );
            if (isSafe) {
              let titles = choice.text.split("\n-");
              if (titles.length === 0) titles = choice.text.split(/\n.\./);
              titles = titles.filter(
                (topic) => topic.length > 5 && !titlesList.includes(topic)
              );
              titlesList.push(...titles);
            }
          }
          counter++;
        } while (titlesList.length < 6 && counter < 5);
        if (titlesList.length > 0)
          return resolve(titlesList.slice(1).map((title) => title.trim()));
        else {
          titlesList = await appActions.getHeadingsByTitle(title);
          return resolve(titlesList);
        }
      } catch (e) {
        reject(e);
      }
    });
  },
  getParagraphs:
    (title, headings, userId, ytbLink, topic, videoId) => async (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        try {
          const configuration = new Configuration({
            apiKey: "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",
          });
          const openai = new OpenAIApi(configuration);
          const paragraphList = {};
          await Promise.all(
            headings.map(async (heading) => {
              const response = await openai.createCompletion(
                "text-davinci-002",
                {
                  prompt: `create a unique blog paragraphs for these heading which utilise the keyword "${topic}": \n\n\n "${heading.topic}" `,
                  temperature: 1,
                  max_tokens: 2500,
                  top_p: 1,
                  frequency_penalty: 2,
                  presence_penalty: 2,
                  user: userId,
                }
              );
              if (
                response.status === 200 &&
                response.data.choices &&
                response.data.choices.length > 0
              ) {
                const choice = response.data.choices[0];
                const isSafe = await appActions.applyContentFilter(
                  choice.text,
                  userId
                );
                if (isSafe)
                  paragraphList[heading.key] = {
                    heading: heading.topic,
                    paragraph: choice.text,
                  };
              }
            })
          );
          const paragraphs = headings.map(
            (heading) => paragraphList[heading.key]
          );
          if (paragraphs.length > 0) {
            const response = await axios.post('https://api.tube2blog.com:5000/job',{
              link:`https://www.youtube.com/watch?v=${videoId}`
            },{
              headers:{
                'Content-Type':"application/json"
              }
            });
            console.log('response', response.data)
            await dispatch({
              type: appActions.BLOG_SAVE,
              payload: {
                blog: paragraphs,
                id: response.data.id,
                ytbLink,
              },
            });
            return resolve(response.data.id);
          } else reject("No Paragraph found");
        } catch (e) {
          reject(e);
        }
      });
    },
  getQuotes: (paragraphs, userId) => async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const configuration = new Configuration({
          apiKey: "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",
        });
        const openai = new OpenAIApi(configuration);
        const quotes = [];
        await Promise.all(
          paragraphs.map(async (paragraph) => {
            const response = await openai.createCompletion("text-davinci-002", {
              prompt: `generate some unique and long quotes from this text: \n\n "${paragraph.paragraph}" `,
              temperature: 0,
              max_tokens: 227,
              top_p: 0.98,
              best_of: 3,
              frequency_penalty: 0,
              presence_penalty: 0,
              user: userId,
            });
            if (
              response.status === 200 &&
              response.data.choices &&
              response.data.choices.length > 0
            ) {
              const choice = response.data.choices[0];
              const isSafe = await appActions.applyContentFilter(
                choice.text,
                userId
              );
              if (isSafe) {
                let titles = choice.text.split("\n");
                titles.forEach((quote) => {
                  if (quote.trim() !== "") {
                    quotes.push(
                      quote.trim().replaceAll('"', "").replace(/.\)/, "")
                    );
                  }
                });
              }
            }
          })
        );
        resolve(quotes);
      } catch (e) {
        reject(e);
      }
    });
  },
  getChapters: () => async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const assembly = axios.create({
          baseURL: "https://api.assemblyai.com/v2",
          headers: {
            authorization: "5ac4850fe1764df39180982f2f1edb93",
            "content-type": "application/json",
          },
        });
        assembly
          .post("/transcript", {
            audio_url:
              "https://www.youtube.com/watch?v=3JdMUhffS_Q&list=PLFX_EwFvKKWNzzu3pxAUOkQqP7RaQ8-Zq&ab_channel=vu",
            auto_chapters: true,
          })
          .then(async (res) => {
            const data = res.data;
            let status = data.status;
            do {
              try {
                const chapters = await assembly.get(`/transcript/${data.id}`);
              } catch (e) {
                console.log(e);
              }
            } while (status !== "complete");
          })
          .catch((err) => console.error(err));
      } catch (e) {
        reject(e);
      }
    });
  },
  initBlog: (videoId, title, topic) => async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await dispatch({
        type: appActions.BLOG_INIT,
        payload: { videoId, title, topic },
      });
      resolve("success");
    });
  },
  getAutoComplete: (text) => {
    return new Promise(async (resolve, reject) => {
      const configuration = new Configuration({
        apiKey: "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",
      });
      const openai = new OpenAIApi(configuration)
      const response = await openai.createCompletion('text-davinci-001',{
        prompt: text.replace(/\.$/, ""),
        temperature: 0.29,
        max_tokens: 64,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
      });
      const resText = response.data.choices[0].text
        .replaceAll('\n\n\n\n\n\n',' ')
        .replaceAll('\n\n\n\n\n',' ')
        .replaceAll('\n\n\n\n',' ')
        .replaceAll('\n\n\n',' ')
        .replaceAll('\n\n',' ')
        .replaceAll('\n',' ')
      resolve(resText)
      console.log('response ', response)
    })
  }
};

export default appActions;
